<template>
  <div class="error-page forbidden-found">
    <div class="error-content">
      <div class="img-wrap">
        <img src="@/assets/images/403.svg" alt="403" />
      </div>
      <div class="info-content">
        <div class="title">
          Forbidden Page
        </div>
        <div class="caption">
          Sorry, you are not authorized to access this page.
        </div>
        <div class="custom-button">
          <a href="javascript:void(0);" @click="goHome">
            {{ buttonLabel }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    errorMessage() {
      return (
        sessionStorage["error-message"] ||
        "Sorry, you are not authorized to access this page."
      );
    },
    buttonLabel() {
      if (this.onlyPlayer()) return "Back to profile list";
      return "Back Home";
    }
  },
  methods: {
    goHome() {
      if (this.onlyPlayer()) {
        this.$router.push("/profile");
        return;
      } else if (this.onlyClubCoach()) {
        this.$router.push(
          `/${localStorage["profile-id"]}/club_profile/summary`
        );
        return;
      } else if (this.onlyCollegeCoach()) {
        this.$router.push(
          `/${localStorage["profile-id"]}/college_profile/summary`
        );
      } else {
        this.$router.push("/");
      }
    }
  }
};
</script>
